import React from 'react';
import './LoginPage.css';

const MicrosoftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" width="18" height="18">
    <path fill="#f25022" d="M0 0h11v11H0z" />
    <path fill="#7fba00" d="M12 0h11v11H12z" />
    <path fill="#00a4ef" d="M0 12h11v11H0z" />
    <path fill="#ffb900" d="M12 12h11v11H12z" />
  </svg>
);

export function LoginPage() {
  const handleLogin = () => {
    window.location.href = '/auth/login/microsoft';
  };

  return (
    <div className="login-page">
      <div className="login-brand-panel">
        <div className="login-brand-content">
          <span className="login-brand-mark" role="img" aria-label="Mariana Minerals" style={{ WebkitMaskImage: 'url(/trident.png)', maskImage: 'url(/trident.png)' }} />
          <h1 className="login-brand-name">Mariana Labs</h1>
          <p className="login-brand-sub">Laboratory Information Management System</p>
        </div>
      </div>

      <div className="login-form-panel">
        <div className="login-form-container">
          <h2 className="login-heading">Sign in to your account</h2>
          <p className="login-subtext">
            Use your Microsoft account to continue
          </p>
          <button className="login-ms-button" onClick={handleLogin}>
            <MicrosoftIcon />
            Sign in with Microsoft
          </button>
          <div className="login-footer">
            <p className="login-footer-text">
              Mariana Minerals &middot; Secure authentication via Microsoft Entra ID
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
